import "./maintenanceHeader.css";

export interface EstadoLeyenda {
  nombre: string;
  // CSS color, e.g. "var(--color-aprobadas)" (utils/main.css)
  color: string;
  texto?: string;
}

interface EstadosLeyendaProps {
  titulo: string;
  estados: EstadoLeyenda[];
  // Partial states share one explanation, shown on its own row
  parciales: EstadoLeyenda[];
  textoParciales: string;
}

/**
 * Informative legend of document states (pill with the table color + what
 * it means). Used in the header of the order and solicitud maintenance
 * tables; each screen passes its own states and texts.
 */
export default function EstadosLeyenda({
  titulo,
  estados,
  parciales,
  textoParciales,
}: EstadosLeyendaProps) {
  return (
    <aside className="eol-leyenda" aria-label="Significado de los estados">
      <div className="eol-titulo">
        <i className="pi pi-info-circle" aria-hidden="true" /> {titulo}
      </div>
      <ul className="eol-lista">
        {estados.map((e) => (
          <li key={e.nombre}>
            <span className="eol-pill" style={{ backgroundColor: e.color }}>
              {e.nombre}
            </span>
            <span className="eol-texto">{e.texto}</span>
          </li>
        ))}
        <li className="eol-parciales">
          <span className="eol-pills">
            {parciales.map((p) => (
              <span
                key={p.nombre}
                className="eol-pill"
                style={{ backgroundColor: p.color }}
              >
                {p.nombre}
              </span>
            ))}
          </span>
          <span className="eol-texto">{textoParciales}</span>
        </li>
      </ul>
    </aside>
  );
}
